export default __webpack_public_path__ + "static/media/payments.cb5c21ab.png";